import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { PresentationChartIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { Route as pathlessAuthenticatedRoute } from '../../route';
import { requireAnyPermission, requireModules } from '../../route';
import { commandCenterSearchSchema } from './commandCenterSearch';

const APCommandCenterPage = lazyRouteComponent(
  () => import('./APCommandCenterPage'),
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/accounts-payable/command-center',
  staticData: {
    app: {
      nav: {
        label: msg('Command Center', {
          context: 'sidebar nav label, Accounts Payable section',
        }),
        icon: <PresentationChartIcon className="h-4 w-4" weight="fill" />,
        group: 'Accounts Payable',
        order: 5,
        groupOrder: 40,
      },
      access: {
        modulesAnyOf: [ProductModule.AP_INVOICING],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.APCommandCenter },
        ],
      },
    },
  },
  component: APCommandCenterPage,
  loader: () => ({
    crumb: msg('Command Center', { context: 'page breadcrumb' }),
  }),
  validateSearch: commandCenterSearchSchema,
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.AP_INVOICING],
    });
    await requireAnyPermission({
      context,
      permissions: [{ action: Action.Read, subject: Subject.APCommandCenter }],
    });
  },
});
